'use strict';

export default {
    user: undefined, // Stores the user object for the API
    hasAccessToData: undefined, // API response to indicate if user has access to the current tenant
    loggedOut: undefined, // Store logout state to prevent infinite redirects/popups
    forceNewTerms: false // Force a display of terms&conditions acceptance
};
